export const environment = {
  production: true,
  urlBase: "https://sistema.agrivem.cl/backend/",
  urlNode: "https://sistema.agrivem.cl/node-back/api/v1/"
};
